'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isPlainObject = {exports: {}};

exports.isPlainObject = isPlainObject;
